import React, { useState, useEffect } from "react";
import "./Payment.css";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useNavigate } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export default function Payment() {

  const params = new URLSearchParams(window?.location?.search);
  const Pay = params?.get("payurl");
  const Tokenid = params?.get("SECURETOKENID");
  const Token = params?.get("SECURETOKEN");
  const Items = params?.get("Item");
  const Topays = params?.get("Topay");
  const PQID = params?.get("pqId");
  const SectionId = params?.get("SectionId");

  const navigate = useNavigate();
  // console.log("/vendorDetails?pqid=" + PQID + "&sectionid=" + SectionId);
  const [isLoading, setIsLoading] = useState(true);

  //  useEffect(() => {
  //   const handleMessage = (event) => {
  //     const messageData = event.data;
  //     if (messageData.status === "success") {
  //       const pqId = +PQID;
  //       if (pqId > 0) {
  //         navigate(`/vendorDetails?pqid=${pqId}&tab=Questionnaire`);
  //       } else {
  //         console.error("No PqId found in url");
  //       }
  //     }
  //   };
  //   window.addEventListener("message", handleMessage);
  //   return () => {
  //     window.removeEventListener("message", handleMessage);
  //   };
  // }, []);

  setTimeout(() => {
    setIsLoading(false)
  }, "5000");

  return (
    <div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme?.zIndex?.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className='container'>
        <div className='window'>
          <div className='order-info'>
            <div className='order-info-content'>
              <h6 className='text-center mt-2' >Order Summary</h6>
              <div className='line'></div>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 450 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: "bold", fontSize: "18px" }}>{Items}</TableCell>
                      <TableCell sx={{ fontWeight: "bold" }} align="right">&nbsp;</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>

                    <TableRow

                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell  >Total</TableCell>
                      <TableCell align="right">{Topays}</TableCell>


                    </TableRow>

                  </TableBody>
                </Table>
              </TableContainer>


            </div>
          </div>
          <br />
          <div className='credit-info'>
            <div className='credit-info-content' >

              <iframe src={Pay + "&SECURETOKEN=" + Token + "&SECURETOKENID=" + Tokenid} style={{ height: "100%", overflow: "hidden" }} />

            </div>
          </div>
        </div></div>
    </div>
  )
}
